<div class="row">
  <div class="col-11 text-center">
    <h2>{{ data.title }}</h2>
  </div>
  <div style="cursor: pointer;">
    <span class="btn-inner--icon"><i class="fas fa-times" (click)="dialogRef.close()"></i></span>
  </div>
</div>

<div class="row">
  <div class="col">
    <app-dynamic-form-builder [fields]="getFields()" [button]="button" [col]="data.col" (onSubmit)="create($event)">
    </app-dynamic-form-builder>
  </div>
</div>